/* eslint quotes: ["error", "single", { "allowTemplateLiterals": true }] */
module.exports = {
  title: 'Will the UK car industry get a good deal?',
  comments: [
    {
      id: 't7JccCZny',
      displayName: 'John_from_Hendon',
      commentText: `Has Boris not yet been sacked?

His use of a profanity to describe all British employers, if done my any other minister would have resulted in immediate dismissal - so why hasn't Maysy sacked him - perhaps she shares his opinion that all British workers should lose their employment - LIKE BORIS.

May's Tory party is a dead man walking - with no standards or integrity.

Kick out Boris.`,
      timestamp: new Date(2018, 5, 26, 12, 3),
      numUpVotes: 6,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 'KJOVydh64C',
      displayName: 'DPJmendoza',
      commentText: `So the withdrawal bill has been made law. were leaving but we have no plan, no plan for no deal, massive uncertainty, 100's of unresolved issues with only months to go, Tories divided and are never going to agree in a billion years.The EU may no be perfect but smashing everything up with no plan is no solution it's absolute insanity. The one certainty in all this is that the Tory party will fall.`,
      timestamp: new Date(2018, 5, 26, 12, 30),
      numUpVotes: 6,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 'klPLTs6rFt',
      displayName: 'Alan C',
      commentText: `The howling mob of Brexiteers don't care what happens to the country just so long as we leave the EU. Shame on them.`,
      timestamp: new Date(2018, 5, 26, 12, 33),
      numUpVotes: 6,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 'HAXvd1Zuyk',
      displayName: 'DPJmendoza',
      commentText: `We elect a PM to act in the best interest of the people and businesses etc, we do not elect a PM to act in the parties own interests and Kotow to likes of Bojo and Ree's Mogg who have there own agendas and devious reasons for wanting to leave. maybe we should all follow the Brexiteers with no plan other than were leaving, destination unknown, absolute insanity!`,
      // new Date(year, monthIndex [, day [, hours [, minutes [, seconds [, milliseconds]]]]]);
      // The argument monthIndex is 0-based. This means that January = 0 and December = 11.
      timestamp: new Date(2018, 5, 26, 12, 47),
      numUpVotes: 1,
      numDownVotes: 0,
      // displayName, replyText, timestamp, numUpVotes, numDownVotes,
      replies: [],
    },
    {
      id: 'bWlRtMc_wb',
      displayName: 'Please no more Brexit job losses',
      commentText: `Senior Tory politician resigns over failure to protect UK jobs.

Start of a trend?`,
      timestamp: new Date(2018, 5, 27, 13, 0),
      numUpVotes: 1,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 'GGUMTgXrAw',
      displayName: 'BBC Remoanbots Paid in Euros to Cry',
      commentText: `My point? EU propagandists lying to the UK full time on here.`,
      timestamp: new Date(2018, 5, 27, 15, 33),
      numUpVotes: 6,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 'n3C3MluZeN',
      displayName: 'CommonSense',
      commentText: `Impose quota's on the foreign can manufacturers if they want to threaten a country. You want to import your French, German vehicles etc, 45% UK content is required`,
      timestamp: new Date(2018, 5, 28, 16, 35),
      numUpVotes: 1,
      numDownVotes: 2,
      replies: [],
    },
    {
      id: '8SdHSy0jXR',
      displayName: 'My Polypersonalities',
      commentText: `Cadence Minerals just spiked up 40% .. sold a few of these ... not all profit but every little helps ...

All in a day when British assets lose more and more and more value.

Still, Brexitear Odey will be enjoying his £200 Million profits betting against Intu I imagine.

:)`,
      timestamp: new Date(2018, 5, 28, 16, 20),
      numUpVotes: 1,
      numDownVotes: 2,
      replies: [],
    },
    {
      id: 'lCDE2s0bpj',
      displayName: '0racle',
      commentText: `Kamal you must stop reporting the facts, you know our far-right Tory bot friends don't like the news being reported.

We all know the type of UK they want and it's not one the vast majority do. Orwellian times will truly be on us if we give up and let them take over the news! `,
      timestamp: new Date(2018, 5, 28, 16, 21),
      numUpVotes: 4,
      numDownVotes: 3,
      replies: [],
    },
    {
      id: 'Hq83XAKaHb',
      displayName: 'Tom Waller',
      commentText: `Harmony. That is why the EU alter UK regulations mostly, not national laws.

Integration is why Scotland and England trade so freely.

That same integration that is the freedom of movement and free trade area which is the EU and Europe.

Scotland, Ireland and Gibraltar support staying in the EU.

Guess what England. Nothing but troubles ahead. Did warn you 2 years ago to Exit Brexit.`,
      timestamp: new Date(2018, 5, 29, 11, 18),
      numUpVotes: 3,
      numDownVotes: 4,
      replies: [],
    },
    {
      id: 'Lp8VY-3JYh',
      displayName: 'longmemory',
      commentText: `Oh well, great for Merkel & Germany

:-) `,
      timestamp: new Date(2018, 5, 30, 11, 44),
      numUpVotes: 3,
      numDownVotes: 2,
      replies: [],
    },
    {
      id: 'KySAiD5ZLq',
      displayName: 'Cap Ferrat',
      commentText: `Yes indeed, looks like Germany is about to change its political leadership with the coalition disintegrating.

EU has typified arrogance and so no surprise that it has found its elf in such a mess.

Uk was only there as a cash cow.


Most Scottish people have now joined the Leave campaign, it’s hardly surprising!!

Euro will fall first closely followed by the EU...

Watch and learn`,
      timestamp: new Date(2018, 5, 30, 15, 52),
      numUpVotes: 4,
      numDownVotes: 3,
      replies: [],
    },
    {
      id: 'L-gSK8MUDO',
      displayName: 'Cap Ferrat',
      commentText: `Oh dear, it seems that yet again there are the same old folk on here, bitterly resenting the democratic decision taken by the majority of the U.K.
I for one, am very happy to cheer on Brexit as it is now unstoppable.
We will stop paying for Romanian motorways soon.
The foreign Remoaners on here pretending to be British do provide plenty of amusement though, and I can’t wait until March 2019.`,
      timestamp: new Date(2018, 6, 1, 10, 21),
      numUpVotes: 4,
      numDownVotes: 3,
      replies: [
        {
          id: 'jzwvq6-OJI',
          displayName: 'mole59',
          replyToId: 'L-gSK8MUDO',
          replyText: `I am not pretending to be british, I am british. When your Isolation starts (and this will not be March 2019, but much later) it will be too late to reverse it. I post my comments on here because I think it is a shame that the UK is taking the wrong path. A path that will lead to long term misery for all that live there. You may think you have won something now but you wait.. `,
          timestamp: new Date(2018, 6, 1, 11, 32),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'hG22UVBwkt',
          displayName: 'Tom Waller',
          replyToId: 'L-gSK8MUDO',
          replyText: `Thank you for your post. If I could have given you more than one up arrow I would have, for you speak the truth and if the Brexit support can not see now how wrong they are then the nation called United Kingdom is lost to history.

The people of Scotland and Northern Ireland will not stand for any form of Brexit.

That is a fact England/Westminster best not ignore.`,
          timestamp: new Date(2018, 6, 2, 12, 37),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'EpowiAE_HK',
          displayName: 'Tom Waller',
          replyToId: 'L-gSK8MUDO',
          replyText: `17.4 million Brexit votes of which all but 2.2 million are ENGLISH from a total UK population of over 64 Million people is not democratic.

NOR was turning down Scotland's request to hold the 2016 referendum to EU Majority rule where 3 out of 4 of the member states of the UK would have to vote for Brexit.`,
          timestamp: new Date(2018, 6, 2, 13, 0),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'HBDNLRiLMFn',
          displayName: 'bigmowlay',
          replyToId: 'L-gSK8MUDO',
          replyText: `They don’t understand, or care. Their only agenda is hatred

May is relying on them to keep her in power

It’s 50-50 whether she will. Tory/lab voter numbers are finely balanced

We need a disruption tactic to work. Scotland/NI is a good bet, so is People’s Vote, there are many others

It needs only one to work to save UK.`,
          timestamp: new Date(2018, 6, 3, 11, 0),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'GO4xtL6H6jk',
          displayName: 'Tom Waller',
          replyToId: 'L-gSK8MUDO',
          replyText: `The UK Gov. make interest on those loans should that happen.

Are you enjoying paying for Calillion public works when the EU would have given up to 85% regional development grants on many of those failed projects, which were never tendered to the EU by the UK.
`,
          timestamp: new Date(2018, 6, 3, 12, 30),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'MClcI5aBWK_',
          displayName: 'Tom Waller',
          replyToId: 'L-gSK8MUDO',
          replyText: `We are doing our best for the UK Sir, here is a nice quote from the Guardian

"A network of Yes groups all across Scotland has begun to regroup and reform. I was sent a list of more than 150 of them and this was by no means complete. This time, they will be demanding more autonomy from SNP central control over independence"`,
          timestamp: new Date(2018, 6, 3, 12, 43),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'PqOX3iX-Hg_',
          displayName: 'Jennayyy',
          replyToId: 'L-gSK8MUDO',
          replyText: `Tom Waller should write for BBC News! He seems to have all the information, not sure if it's the right information but still information.`,
          timestamp: new Date(2018, 6, 3, 13, 43),
          numUpVotes: 0,
          numDownVotes: 0,
        },
      ],
    },
    {
      id: 'ipJVUELli5c',
      displayName: 'SnowyDay',
      commentText: `Germany knocked out of the World Cup, Merkel next ? Then the EU ? Better stay in the UK guys, the EU's going down`,
      timestamp: new Date(2018, 6, 1, 11, 8),
      numUpVotes: 1,
      numDownVotes: 1,
      replies: [],
    },
    {
      id: '0oCaCvhS6mx',
      displayName: 'make sense',
      commentText: `Theres always Macron to take over once Merkel falls. Oh wait! Hes busy building a private swimming pool and buying crockery!`,
      timestamp: new Date(2018, 6, 2, 12, 23),
      numUpVotes: 0,
      numDownVotes: 1,
      replies: [],
    },
    {
      id: 'gEbNZyOC6y7',
      displayName: 'EddieEagle',
      commentText: `We are ending up with a soft Brexit. And the Quitters only have themselves to blame for this by failing to deliver the promised benefits. Not the EU’s fault, migrants or Remain supporters, it’s the lying Quitters, Tories and UKIP bigots’ fault for believing in their own lies. Bye bye cliff edge 👋 and welcome to what’s best for Britain 🇬🇧`,
      timestamp: new Date(2018, 6, 2, 13, 2),
      numUpVotes: 0,
      numDownVotes: 0,
      replies: [
        {
          id: 'aoXW7Kd33eL',
          displayName: 'anotherfakename',
          replyToId: 'gEbNZyOC6y7',
          replyText: `Several points. a) We arent out so how can we deliver the benefits of being out. b) May, the government, mps and civil service making a mess of the whole issue are remainers. c) we ended here because those listed in b do not, have not and will never believe in Britain.
Yes we will end up without leaving, and the UK will suffer from remaining in all the costs and rules as it has for 40 year`,
          timestamp: new Date(2018, 6, 3, 13, 21),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'urwooYAjEmP',
          displayName: 'EddieEagle',
          replyToId: 'gEbNZyOC6y7',
          replyText: ` It’s worthwhile remembering that Brexit was supposed to make us better off. But it’s not it’s a fiasco! We have reached the point now that the lying Quitters preach destruction of our economy is exactly what the country voted for... wasn’t on the big red bus or ballot paper was it? Stop Brexit - it only leads to costs and decline`,
          timestamp: new Date(2018, 6, 3, 10, 0),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'XjJNiTU6KtP',
          displayName: 'Tom Waller',
          replyToId: 'gEbNZyOC6y7',
          replyText: `Quote BBC "There is no Brexit dividend for our industry, particularly in what is an increasingly hostile and protectionist global trading environment.

Our message to government is that until it can demonstrate exactly how a new model for customs and trade with the EU can replicate the benefits we currently enjoy, don't change it."`,
          timestamp: new Date(2018, 6, 3, 11, 30),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'y-XDZsENFAO',
          displayName: 'anotherfakename',
          replyToId: 'gEbNZyOC6y7',
          replyText: `What benefits? A massive and growing trade deficit is NOT a benefit to us. We can set tariffs as we like which could mean no tariffs on incoming parts for cars built here. I think in the long term we would want to change that though. We can also use tariffs collected on complete cars to lower tax and energy costs for manufacturers here to ensure they can afford tariffs into the EU. No probs`,
          timestamp: new Date(2018, 6, 3, 12, 0),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'P42IX_dXdvn',
          displayName: 'british patriot',
          replyToId: 'gEbNZyOC6y7',
          replyText: `We don't need cars or planes or employees or tax revenue or jobs.

( I've got 500 Unicorn eggs. Up West they'll charge you £1m each, I can let you have them for a 'pony' a piece or 5 for a 'monkey'...guaranteed to turn base metal into pure gold..cash only......................eggs may be gold painted duck eggs, buyer beware, only for holders of Blue Passports..it's the will of the people, innit)`,
          timestamp: new Date(2018, 6, 3, 13, 0),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'ENSbsndqy_K',
          displayName: 'iliketurtles',
          replyToId: 'gEbNZyOC6y7',
          replyText: `Are you trying to make a funny british patriot?`,
          timestamp: new Date(2018, 6, 3, 13, 30),
          numUpVotes: 0,
          numDownVotes: 0,
        },
        {
          id: 'HXjt5mYS2Ob',
          displayName: 'manchestermanny',
          replyToId: 'gEbNZyOC6y7',
          replyText: `It's hard for me to say this but I totally agree with anotherfakename!`,
          timestamp: new Date(2018, 6, 3, 14, 0),
          numUpVotes: 0,
          numDownVotes: 0,
        },
      ],
    },
    {
      id: 'kgsyp-kDmc7',
      displayName: 'londonbob',
      commentText: `Tick tock tick tock barnier`,
      timestamp: new Date(2018, 6, 3, 13, 30),
      numUpVotes: 0,
      numDownVotes: 0,
      replies: [],
    },
    {
      id: 'RvwEThKAfK6',
      displayName: 'icecoldstevet',
      commentText: `Although investment is lower at present it is still significant even though Brexit is now happening (repeal of 1972 act taking us out is now law). Lower level of investment could also be due to cyclical and other reasons.

We want to see all business thrive but most of this noise is from large corporations. Also remember out of 26m employed in UK 22m are employed by SME's or the public sector`,
      timestamp: new Date(2018, 6, 3, 14, 0),
      numUpVotes: 1,
      numDownVotes: 1,
      replies: [],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/comments-core.js